module.exports = __webpack_public_path__ + "static/media/7.4ca191b5.jpg";